import { createApp } from 'vue';
import { createYmaps } from 'vue-yandex-maps';
import VueKonva from 'vue-konva';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import '@fontsource/inter';
import './styles/tailwind.css';
import './styles/main.css';
import { useAuthStore } from './store/auth';
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import i18n from './i18n';

const app = createApp(App);
app.use(createYmaps({
    apikey: 'a8e2e142-a157-4779-9d8b-a1e54e94a96e',
    lang: 'ru_RU',
    strictMode: true
  }));
app.component("dotlottie-vue", DotLottieVue);
app.use(createPinia());
app.use(i18n)
app.use(VueKonva);

async function bootstrap() {
    console.log('bootstrap');
    const auth = useAuthStore()
    console.log('bootstrap: validating tokens...');
    await auth.validateTokens();
    console.log('bootstrap: validating tokens completed');
    app.use(router);
    app.mount('#app');
}
bootstrap();
